import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';

export default class extends Controller {
  static values = {
    url: String,
    isFavorite: Boolean
  };

  save = async (e) => {
    e.preventDefault();
    const { saveVacancyId } = e.currentTarget.dataset;
    if (!saveVacancyId) return;

    // Extract current page parameters
    const params = new URLSearchParams(window.location.search);

    const response = await patch(this.urlValue, {
      responseKind: 'turbo-stream',
      body: JSON.stringify({
        page: params.get('page')
      })
    });

    if (response.ok) {
      const buttons = document.querySelectorAll(
        `[data-save-vacancy-id="${saveVacancyId}"]`
      );
      buttons.forEach((element) => {
        element.classList.toggle('-is-active');
      });
    }
  };
}
